<template>
  <nav class="header-tab">
    <div class="dropdown">
      <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div class="header-tab-block" active-class="active">{{$t("header.nav.tab6")}}</div>
      </div>
      <div class="dropdown-menu">
        <a
          :href="langToDataRide()"
          target="_blank"
          class="header-tab-block drop-item"
        >{{$t("header.nav.tab8")}}</a>
        <router-link
          tag="a"
          :to="langTo('/ncdn/')"
          class="header-tab-block drop-item"
          active-class="active"
        >{{$t("header.nav.tab7")}}</router-link>
        <a
          :href="langTo('/nMobile/')"
          target="_blank"
          class="header-tab-block drop-item"
        >{{$t("header.nav.tab11")}}</a>
        <a
          :href="langTo('/nMobile-pro/')"
          target="_blank"
          class="header-tab-block drop-item"
        >{{$t("header.nav.tab13")}}</a>
      </div>
    </div>

    <router-link
      tag="a"
      :to="langTo('/developer/')"
      class="header-tab-block"
      active-class="active"
    >{{$t("header.nav.tab1")}}</router-link>
    <router-link
      tag="a"
      :to="langTo('/miner/')"
      class="header-tab-block"
      active-class="active"
    >{{$t("header.nav.tab2")}}</router-link>
    <!--  <router-link tag="a" :to="langTo('/partner/')" class="header-tab-block" active-class="active">{{$t("header.nav.tab3")}}</router-link>-->
    <!-- <router-link
      tag="a"
      :to="langToBlog('')"
      class="header-tab-block"
      active-class="active"
    >{{$t("header.nav.tab12")}}</router-link>-->
    <a
      :href="langToBlog()"
      target="_blank"
      class="header-tab-block drop-item"
    >{{$t("header.nav.tab12")}}</a>
    <a
      :href="$url.FOOTER_LINK.community.forum"
      target="_blank"
      class="header-tab-block"
      active-class="active"
    >
      <span>{{$t("footer.community.tab7")}}</span>
    </a>
    <!--  <router-link tag="a" :to="langTo('/about/')" class="header-tab-block" active-class="active">{{$t("header.nav.tab5")}}</router-link>-->
    <div class="dropdown">
      <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div class="header-tab-block" active-class="active">{{$t("header.nav.tab5")}}</div>
      </div>
      <div class="dropdown-menu">
        <a
          @click="scrollTo(langTo('/about/'),'#team')"
          class="header-tab-block drop-item"
          active-class="active"
        >{{$t("header.nav.tab9")}}</a>
        <a
          @click="scrollTo(langTo('/about/'),'#partner')"
          class="header-tab-block drop-item"
          active-class="active"
        >{{$t("header.nav.tab3")}}</a>
        <a
          @click="scrollTo(langTo('/about/'),'#roadmap')"
          class="header-tab-block drop-item"
          active-class="active"
        >{{$t("header.nav.tab10")}}</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  mounted() {
    // document.getElementById(this.$router.currentRoute.hash).scrollIntoView();
  },
  methods: {
    langTo(path) {
      let root = "";
      if (!!this.$route.params.lang) {
        root = `/${this.$route.params.lang}`;
      }
      return `${root}${path}`;
    },
    langToBlog() {
      if (this.$route.params.lang === "zh") {
        return `https://blog.nkn.org/?cat=131`;
      } else {
        return `https://blog.nkn.org`;
      }
    },
    langToDataRide() {
      if (this.$route.params.lang === "zh") {
        return `https://dataride.nkn.org/zh/`;
      } else {
        return `https://dataride.nkn.org`;
      }
    },
    scrollTo(path, target) {
      this.$router.push(path);
      this.$nextTick(() => {
        document.getElementById(target).scrollIntoView();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header-tab {
  display: flex;
  min-width: 500px;
  max-width: 800px;
  justify-content: space-around;
  flex-grow: 1;
  flex-shrink: 1;
  a {
    text-decoration: none;
  }
  a:hover {
    color: #24397d !important;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }

  &-block {
    cursor: pointer;
    @include nkn-font-set(14px, #24397d, 600);
    &:hover {
      color: #1791f2;
    }
  }

  .active {
    color: #1791f2;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/nknHeaderNav.vue